import { validate_non_empty_string } from '@/utils/validations/validate_inputs';

export default {
  methods: {
    add_create_section() {
      if (!validate_non_empty_string(this.create_new_section_title)) {
        this.show_error('Section title must not be empty.');
        return;
      }
      this.create_job_sections.push({
        title: this.create_new_section_title,
        descriptions: [''],
        columns: [],
        table: null,
        show_on_advert: true,
      });
      this.create_new_section_title = '';
      this.create_active_section_index = this.create_job_sections.length - 1;
      this.has_extraction_preview = this.create_job_sections.length > 0;
    },

    remove_create_section(index) {
      this.create_job_sections.splice(index, 1);
      const next_index = Math.min(this.create_active_section_index, this.create_job_sections.length - 1);
      this.create_active_section_index = next_index < 0 ? 0 : next_index;
      this.has_extraction_preview = this.create_job_sections.length > 0;
    },

    set_active_create_section(index) {
      if (index < 0 || index >= this.create_job_sections.length) return;
      this.create_active_section_index = index;
    },

    add_create_description_entry(section_index) {
      const section = this.safe_array_get(this.create_job_sections, section_index);
      if (!section) return;
      if (!Array.isArray(section.descriptions)) section.descriptions = [''];
      section.descriptions.push('');
    },

    remove_create_description_entry(section_index, desc_index) {
      const section = this.safe_array_get(this.create_job_sections, section_index);
      if (!section || !Array.isArray(section.descriptions)) return;
      if (section.descriptions.length === 1) {
        this.safe_array_set(section.descriptions, 0, '');
        return;
      }
      section.descriptions.splice(desc_index, 1);
    },

    add_job_profile_section() {
      if (!validate_non_empty_string(this.new_section_title)) {
        this.show_error('Section title must not be empty.');
        return;
      }
      this.view_job_sections.push({
        title: this.new_section_title,
        descriptions: [''],
        columns: [],
        table: null,
        show_on_advert: true,
      });
      this.view_active_section_index = this.view_job_sections.length - 1;
      this.new_section_title = '';
    },

    remove_job_profile_section(index) {
      this.view_job_sections.splice(index, 1);
      const next = Math.min(this.view_active_section_index, this.view_job_sections.length - 1);
      this.view_active_section_index = next < 0 ? 0 : next;
    },

    set_active_view_section(index) {
      if (index < 0 || index >= this.view_job_sections.length) return;
      this.view_active_section_index = index;
    },

    add_view_description_entry(section_index) {
      const section = this.safe_array_get(this.view_job_sections, section_index);
      if (!section) return;
      if (!Array.isArray(section.descriptions)) section.descriptions = [''];
      section.descriptions.push('');
    },

    remove_view_description_entry(section_index, desc_index) {
      const section = this.safe_array_get(this.view_job_sections, section_index);
      if (!section || !Array.isArray(section.descriptions)) return;
      if (section.descriptions.length === 1) {
        this.safe_array_set(section.descriptions, 0, '');
        return;
      }
      section.descriptions.splice(desc_index, 1);
    },

    set_view_mode(mode) {
      if (!['preview', 'edit', 'split'].includes(mode)) return;
      this.view_mode = mode;
    },

    section_label(index) {
      const pos = Number(index);
      if (Number.isNaN(pos) || pos < 0) return '';
      const alpha_count = 26;
      const base_code = 'A'.charCodeAt(0);
      const letter = String.fromCharCode(base_code + (pos % alpha_count));
      const cycle = Math.floor(pos / alpha_count);
      return cycle > 0 ? `${letter}${cycle}` : letter;
    },
  },
};
